module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am398-559eea660f06bc237b23fac5d8539aa3.jpg";